import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';

import { Process } from 'app/shared/models/process.model';

import { ProcessService } from './../process.service';
import {ConstantsService} from "../../../services/constants-service";

@Component({
  templateUrl: './process-details.component.html',
  providers: [ProcessService]
})

/**
 * Dialog component to display process details.
 */
export class ProcessDetailsComponent implements OnInit {
  processDetailsForm: FormGroup;
  argProcessDetailsData: Process;
  private image:any;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private processService: ProcessService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.image = ConstantsService.APP_BE_URL
      + ConstantsService.PROCESS_IMAGE_DEFINITION_SERVLET
      + '?processDefId=' + this.argProcessDetailsData.id;
    this.buildForm();
  }

  buildForm() {
    this.processDetailsForm = this.formBuilder.group({
      processId: [{ value: this.argProcessDetailsData.id, disabled: true }],
      processName: [{ value: this.argProcessDetailsData.name, disabled: true }],
      processVersion: [{ value: this.argProcessDetailsData.version, disabled: true }],
      processDescription: [{ value: this.argProcessDetailsData.description, disabled: true }],
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/processes/processdetails/process-details.component.ts